import React from "react";
import { useNavigate } from "react-router-dom";
import { Upload, Download, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionShell, SCard } from "./SettingsUI";
import { cn } from "@/lib/utils";
import { useLang, translateFr as tfr } from "@/i18n";

const INTEGRATIONS = (overview) => [
  { id: "google", name: "Google", desc: tfr("Connexion à votre compte Athlynx via Google."), connected: overview?.profile?.auth_provider === "google" },
  { id: "stripe", name: "Stripe", desc: tfr("Paiement sécurisé de votre abonnement Athlynx."), connected: Boolean(overview?.subscription?.stripe_customer_id_present) },
  { id: "resend", name: "Emails de sécurité (Resend)", desc: tfr("Alertes de sécurité et codes de vérification par email."), soon: true },
  { id: "gcal", name: "Google Calendar", desc: tfr("Synchronisation de votre calendrier Athlynx."), soon: true },
  { id: "yousign", name: "Yousign", desc: tfr("Signature électronique certifiée de vos contrats."), soon: true },
];

export const SectionIntegrations = ({ overview }) => {
  const { tf } = useLang();
  return (
  <SectionShell title={tf("Intégrations")} desc={tf("Services connectés à votre espace Athlynx.")} testid="section-integrations">
    <div className="space-y-2">
      {INTEGRATIONS(overview).map((i) => (
        <div key={i.id} className="flex items-center justify-between gap-3 rounded-2xl border border-white/[0.07] bg-surface p-4" data-testid={`integration-${i.id}`}>
          <div className="min-w-0">
            <p className="text-sm font-medium">{i.name}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{tf(i.desc)}</p>
          </div>
          <span className={cn("text-[11px] rounded-full border px-2.5 py-1 shrink-0",
            i.soon ? "text-muted-foreground border-white/[0.1]"
              : i.connected ? "text-green-500 border-green-500/25 bg-green-500/[0.06]"
                : "text-muted-foreground border-white/[0.1]")}>
            {i.soon ? tf("Bientôt disponible") : i.connected ? tf("Connecté") : tf("Non connecté")}
          </span>
        </div>
      ))}
    </div>
  </SectionShell>
  );
};

export const SectionImportExport = () => {
  const { tf } = useLang();
  const navigate = useNavigate();
  return (
    <SectionShell title={tf("Import / Export")} desc={tf("Importez et exportez vos données Athlynx.")} testid="section-import-export">
      <SCard title={tf("Import de données")} desc={tf("Importez vos athlètes par CSV ou grâce à l'import assisté par IA.")} testid="import-card">
        <Button onClick={() => navigate("/import")} data-testid="goto-import-btn">
          <Upload className="h-4 w-4 mr-1.5" /> {tf("Ouvrir l'import")} <ArrowUpRight className="h-3.5 w-3.5 ml-1.5" />
        </Button>
      </SCard>
      <SCard title={tf("Export de données")} desc={tf("Téléchargez l'ensemble de vos données depuis Données & confidentialité.")} testid="export-link-card">
        <Button variant="outline" onClick={() => navigate("/settings/data")} data-testid="goto-export-btn">
          <Download className="h-4 w-4 mr-1.5" /> {tf("Exporter mes données")}
        </Button>
      </SCard>
    </SectionShell>
  );
};
